import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

interface Props{
    percent: number
    error: boolean
}
export default function DatabaseLoadingBar({percent, error}:Props){
    return (
        <>
            <StyledLoadingBar>
                <div className="bar">
                    <div className={`bar--progress${error?'__error':''}`} style={{ width: percent +'%'}} />
                </div>
                {error? 
                    (<div className="error">
                       <i className="far fa-info-circle"></i>
                    </div>):
                    (<div className={`check${percent === 100? '--complete':''}`}>
                        <i className="fas fa-check"></i>
                    </div>)
                }
                
            </StyledLoadingBar>
        </>
    )
}

const StyledLoadingBar = styled.div`
    display: flex;
    flex-direction: row;
    .bar{
        width: 96px;
        height: 6px;
        border-radius: 50px;
        background: #EEEEEE;
        margin: 14px 8px 13px 16px;    
        &--progress{
            background:#37A3EF;
            height: 6px;
            border-radius: 50px;
            &__error{
                background:#D9534F;
                height: 6px;
                border-radius: 50px;
            }
        }
    }
    .check{
        margin: 12px 16px 12px 0;
        font-size: 8px;
        &--complete{
            color: #01C292;
            margin: 12px 16px 12px 0;
            font-size: 8px;
        }
    }
    .error{
        color: #C43535;
        margin: 9px 16px 10px 0;
        font-size: 12px;
    }
`
